/**
 * @Description
 */
import { CSSProperties, FC, forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { v4 } from 'uuid';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import { message } from 'antd';
import IconFont from '@/common/components/IconFont';
import { layerBaseZIndex, MapView, toolSpecialOpenZIndex } from '@/views/youth/pages/map/ts-config';
import AddForm from '@/views/youth/pages/map/components/MapCon/CityView/CheckInFieldA/AddForm';
import MarkerIcon from '@/views/youth/pages/map/components/MapCon/CityView/CheckInFieldA/MarkerIcon';
import { postCheckInQueryTaskModelList } from '@/common/api/youth';
import CheckList from '@/views/youth/pages/map/components/MapCon/CityView/CheckInFieldA/CheckList';
import { isNotEmptyAny } from '@lhb/func';
import { showMarker } from '@/common/utils/map';
import { useBigdataFn } from '@/common/utils/bigdata';
import { getLngLatAddress } from '../../Map/V2AMap/utils/amap';
import V2Message from '../../Others/V2Hint/V2Message';
/** 点覆盖物层级 */
export const POINT_MARKER_Z_INDEX = layerBaseZIndex.footPrint;
/** 点覆盖物扩展数据 */
interface MarkerExtDataProps { uid?: string | number, lng: string, lat: string }

/**
 * 插件-新增打靶任务
 * 组件如果直接使用在Amap组件下会自动注入_mapIns
 */
const CheckInFieldA: FC<{
  _mapIns?: any;
  mapView?: MapView,
  cityId?: number;
  style?: CSSProperties;
  className?: string;
  URLParamsRef?: any;
  /** 当前是否选中 */
  setSelected?: any;
  clearClickEvent: Function;
  addClickEvent: Function;
  targetOperation?: String;
  setTargetOperation?: Function;
  /** 外部是否选中了地图操作按钮 */
  isCheckOutsideMapOperate?: boolean;
  /** 工具箱内部是否已选中地图操作按钮，用于与该组件外的地图操作功能互斥（目前有地图踩点、标记、测距） */
  setIsCheckInsideMapOperate?: Function;
  setIsCheckOutsideMapOperate?: Function;
  /** 是否全屏 */
  isFull: boolean,
  /** （顶部筛选）是否显示地图踩点 */
  showFootPrint?: boolean,
  /** 设置是否显示工具箱 */
  setIsShowBox: Function,
  /** 打靶任务别名 */
  targetPunchInAlias: string,
  /** 刷新地图数据 */
  onRefreshCheckInData:Function;
  toolOpen?: boolean;
  clearAllLayer?: Function;
  ref?: any,
}> = forwardRef(({
  _mapIns,
  mapView,
  // cityId,
  style,
  className,
  setSelected,
  clearClickEvent,
  addClickEvent,
  targetOperation,
  setTargetOperation,
  isCheckOutsideMapOperate,
  setIsCheckInsideMapOperate,
  setIsCheckOutsideMapOperate,
  setIsShowBox,
  toolOpen,
  targetPunchInAlias,
  onRefreshCheckInData,
  // isFull
}, ref) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook

  useImperativeHandle(ref, () => ({
    quitFootPrint: methods.quitFootPrint,
  }));
  const [status, setStatus] = useState<boolean>(false);
  const [geocoderIns, setGeocoderIns] = useState<any>(null);

  // 注意：对应的图层都应该具有相关的 destroy 事件，统一在 clear 中调用
  /** 点覆盖物分组 */
  const [overlayGroupIns, setOverlayGroupIns] = useState<any>(null);

  const editRef = useRef<any>(null);
  const checkListRef: any = useRef();
  const taskModelListParamsRef: any = useRef(); // 缓存查询列表参数，用来刷新
  const markerRef = useRef<any>(null);

  /* hooks */
  useEffect(() => {
    return () => {
      methods.clear();
    };
  }, []);

  useEffect(() => {
    methods.init();
  }, [_mapIns, mapView]);

  // 打开后创建Marker（为了能够标记）
  useEffect(() => {
    if (targetOperation === 'checkInFieldA') {
      const center = _mapIns.getCenter();
      const marker = new window.AMap.Marker({
        position: center,
        anchor: 'center',
        bubble: true,
        zIndex: 1,
      });
      markerRef.current = marker;
      _mapIns && _mapIns.add(marker);
      showMarker(marker, <div style={{
        width: '100vw',
        height: '100vh',
        background: 'transparent',
      }}>
      </div>);
    } else {
      markerRef.current && _mapIns.remove(markerRef.current);
      markerRef.current = null;
    }

    return () => {
      markerRef.current && _mapIns.remove(markerRef.current);
      markerRef.current = null;
    };
  }, [targetOperation]);



  // useEffect(() => {
  //   if (isFull) {
  //     methods.quitFootPrint();
  //   }
  // }, [isFull]);

  useEffect(() => {
    if (targetOperation !== 'checkInFieldA' || isCheckOutsideMapOperate || mapView !== MapView.City) {
      setStatus(false);
    }
  }, [targetOperation, isCheckOutsideMapOperate, mapView]);

  useEffect(() => {
    setSelected(status ? 1 : 0);
    if (!status) {
      _mapIns?.off('click', methods.clickMapCreateFootPrint);
      addClickEvent && addClickEvent();
      setTargetOperation && setTargetOperation('');
    }
  }, [status]);

  const methods = useMethods({

    init() {
      if (!_mapIns) {
        return;
      }

      methods.clear();

      // 城市模式下生效：添加点覆盖物
      if (mapView === MapView.City) {
        // form表单marker
        editRef.current = new window.AMap.Marker({
          content: ' ',
          offset: new window.AMap.Pixel(10, -100),
          zIndex: 500,
          // draggable: true, // 主动设置可拖拽，但是在拖拽的时候不执行来达到目的
        });

        _mapIns.add(editRef.current);
        const geocoder = new window.AMap.Geocoder({ extensions: 'all' });
        setGeocoderIns(geocoder);
        const _overlayGroup = new window.AMap.OverlayGroup();
        _mapIns.add(_overlayGroup);
        setOverlayGroupIns(_overlayGroup);

        if (status) { // clear 会卸载，所以需要重新绑定
          _mapIns && _mapIns.on('click', methods.clickMapCreateFootPrint);
        }
      }
    },
    /** 清空内容 */
    clear() {
      _mapIns?.off('click', methods.clickMapCreateFootPrint);
      methods.destroyPointMarkers();
    },
    /** 开启地图踩点 */
    startFootPrint() {
      setIsCheckOutsideMapOperate?.(false);
      setIsCheckInsideMapOperate?.(true);
      setStatus(true);
      setIsShowBox(false);
      clearClickEvent && clearClickEvent();
      _mapIns && _mapIns.on('click', methods.clickMapCreateFootPrint);
      setTargetOperation && setTargetOperation('checkInFieldA');
      bigdataFn('038a0113-4b6c-4fe6-aa75-35d837ba1a6a', '打靶任务', '点击了点打靶任务', { op_block: '工具箱', op_event: ``, });
    },
    /** 退出地图踩点 */
    quitFootPrint() {
      setIsCheckInsideMapOperate?.(false);
      setStatus(false);
      addClickEvent && addClickEvent(); // 恢复地图点击事件
      _mapIns?.off('click', methods.clickMapCreateFootPrint);
      setTargetOperation && setTargetOperation('');
    },

    /** 点击事件，切换地图踩点 */
    triggleFootPrint() {
      if (status) {
        methods.quitFootPrint();
      } else {
        methods.startFootPrint();
      }
    },

    /** 监听地图点击事件，创建地图踩点 */
    async clickMapCreateFootPrint(e) {
      if (!e) {
        return;
      }
      const params = {
        lng: e.lnglat.getLng(),
        lat: e.lnglat.getLat(),
        radius: 300
      };

      const data = await methods.getTaskModelList(params);
      if (Array.isArray(data) && data.length) {
        checkListRef.current?.init?.(data);
      } else {
        methods.createPointMarker(params);
        methods.createCheckIn(e.lnglat.getLng(), e.lnglat.getLat());
      }
    },
    async getTaskModelList(params) {
      if (isNotEmptyAny(params)) {
        taskModelListParamsRef.current = params;
      }
      const { data } = await postCheckInQueryTaskModelList(params);
      return data;
    },
    /** 删除打靶刷新列表 */
    async onRefreshCheckList() {
      const data = await methods.getTaskModelList(taskModelListParamsRef.current);
      checkListRef.current?.refresh?.(data);
      onRefreshCheckInData?.();
    },
    /** 提示列表中继续新增任务，直接从缓存数据去经纬度 */
    async onContinueCheckIn() {

      const { lng, lat } = taskModelListParamsRef.current;
      try {
        const addressInfo = await methods.getAddress(lng, lat);
        return addressInfo;
      } catch (err) {
        console.error('获取地址失败:', err);
        return null;
      }
    },
    /**
     * @description 获取周边几百米内的POI数据
     */
    getSurroundPoiList(keyword: string = '', lng, lat) {
      console.log('123', lng, lat);
      if (!lng || !lat) return;

      return new Promise((resolve) => {
        // 构造地点查询类
        var placeSearch = new window.AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // autoFitView: true // 是否自动调整地图视野使绘制的
        });
        placeSearch.searchNearBy(keyword, [lng, lat], 100, (status, result) => {
          if (result?.info !== 'OK') {
            resolve([]); // 或者 reject('查询失败')
            return;
          };
          if (!isNotEmptyAny(result)) {
            resolve([]);
            return;
          }
          const pois = result.poiList?.pois?.filter((item: any) => item.id && item.name && item.address);
          resolve(pois || []);
        });

      });
    },
    getAddress(lng, lat) {
      return new Promise(async (resolve, reject) => {
        if (!geocoderIns) {
          message.warning('地理编码器尚未初始化');
          return reject('Geocoder not initialized');
        }
        const addressInfo: any = await getLngLatAddress([lng, lat], '', false);
        const { pois = [] } = addressInfo;
        // 这里再去查一下附近的poiid，防止创建的点poidid重复
        const poiList = await methods.getSurroundPoiList('', lng, lat) as any[];
        if (!pois?.length && !poiList?.length) {
          V2Message.error('附近暂无poi请重试');
          reject();
          return;
        };
        const { province, city, district, township, street, streetNumber } = addressInfo.addressComponent;
        const params = {
          lng,
          lat,
          address: `${township || ''}${street || ''}${streetNumber || ''}`,
          provinceName: province,
          cityName: city || province,
          districtName: district || city || province,
          poiId: poiList?.length ? poiList[0]?.id : pois[0]?.id
        };
        resolve(params);

      });
    },
    /** 创建地图踩点 */
    async createCheckIn(lng, lat) {
      // 根据经纬度获取地点名称和地址
      const addressInfo = await methods.getAddress(lng, lat);
      // 弹出创建踩点弹窗
      // 编辑图形和绘制图形后，都需要更新formMarker的位置
      editRef.current.setContent(` `);
      editRef.current.setPosition([lng, lat]);
      // 绘制图形后需要生成formMarker的内容
      const uid: any = v4();
      editRef.current.setContent(`<div id="${uid}"></div>`);
      ReactDOM.render(
        <AddForm
          marker={editRef}
          addressInfo={addressInfo}
          onClose={methods.destroyPointMarkers}
          _mapIns={_mapIns}
          targetPunchInAlias={targetPunchInAlias}
        />,
        document.getElementById(uid)
      );
    },
    /** 创建地图踩点 */
    createPointMarker(value: { lng, lat }) {
      if (!value || !value.lng || !value.lat) {
        return;
      }
      const overlays = overlayGroupIns?.getOverlays();
      if (Array.isArray(overlays)) {
        _mapIns.remove(overlays);
        overlayGroupIns && overlayGroupIns.clearOverlays();
      }
      const uid = v4();
      const extData: MarkerExtDataProps = { uid, lng: value.lng, lat: value.lat };
      const marker = new window.AMap.Marker({
        position: [+value.lng, +value.lat],
        anchor: 'bottom-center',
        // zIndex: toolOpen ? toolSpecialOpenZIndex.footPrint : layerBaseZIndex.footPrint,
        zIndex: toolSpecialOpenZIndex.footPrint,
        bubble: true, // 允许冒泡
        extData,
      });

      marker.setContent(`<div id="${uid}"></div>`);

      overlayGroupIns?.addOverlay(marker);
      // _mapIns.add(marker);

      ReactDOM.render(<MarkerIcon />, document.getElementById(uid));
      return marker;
    },
    /** 销毁点覆盖物 */
    destroyPointMarkers(shouldRefresh = false) {
      if (!_mapIns) {
        return;
      }
      const overlays = overlayGroupIns?.getOverlays();
      if (Array.isArray(overlays)) {
        setTimeout(() => {
          _mapIns.remove(overlays);
          overlayGroupIns && overlayGroupIns.clearOverlays();
        }, 200);
      }
      shouldRefresh && onRefreshCheckInData();
    },
  });

  useEffect(() => {
    if (overlayGroupIns) {
      const overlays = overlayGroupIns?.getOverlays();

      if (Array.isArray(overlays)) {
        overlays.forEach(item => {
          item?.setzIndex(toolOpen ? toolSpecialOpenZIndex.footPrint : layerBaseZIndex.footPrint);
        });
      }

    }
  }, [toolOpen]);

  return <>
    <ToolBoxButton active={!!status} className={className} style={style} onClick={methods.triggleFootPrint} targetPunchInAlias={targetPunchInAlias}/>

    <CheckList
      ref={checkListRef}
      targetPunchInAlias={targetPunchInAlias}
      onRefresh={methods.onRefreshCheckList}
      onContinueCheckIn={methods.onContinueCheckIn}
    />

  </>;
});


/**
 * 工具箱按钮
 * @description
 * @demo
 */
const ToolBoxButton:FC<{
  active: boolean,
  className?: string,
  style?: CSSProperties;
  onClick?: any;
  targetPunchInAlias?:string;
}> = ({ active = false, className, style, onClick, targetPunchInAlias }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div
    className={
      cs(styles.satellite,
        className,
        'bg-fff pointer selectNone',
        active && styles.satelliteSelected)
    }
    onClick={onClick}
    style={style} >
    <div className={ cs(styles.satelliteCon, active && styles.satelliteConSelected) }>
      <IconFont
        iconHref='iconshapan_dingwei' />
      <span className='inline-block ml-6 c-222'>{targetPunchInAlias}任务</span>
    </div>
  </div>);
};



/**
 * 退出地图踩点
 * @description
 * @demo
 */
export const QuitFootPrint:FC<{ style?: CSSProperties, quitFootPrint, targetPunchInAlias:string }> = ({ style, quitFootPrint, targetPunchInAlias }) => {

  return <div className={styles.quitFootPrintWrapper}>
    <ToolBoxButton active={true} style={style} targetPunchInAlias={targetPunchInAlias}/>
    <div className={styles.quitFootPrint} onClick={quitFootPrint}>退出{targetPunchInAlias}</div>
  </div>;
};


export default memo(CheckInFieldA);
